export default "__VITE_ASSET__DZAINTo$__"